import type { ConditionGroup, HouseholdPerson, NextPageParams, PaginationMetadata } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"
import { appendConditionGroupParams, appendViewSortParams } from "@/hooks/api/condition-group-params"

export type HouseholdRecordType = "client" | "prospect"

interface HouseholdPeopleApiResponse {
  clients?: HouseholdPerson[]
  prospects?: HouseholdPerson[]
  pagination: PaginationMetadata
}

export interface HouseholdPeopleResponse {
  people: HouseholdPerson[]
  pagination: PaginationMetadata
}

export async function fetchHouseholdPeople(
  context: ApiContext,
  recordType: HouseholdRecordType,
  viewFilterGroup?: ConditionGroup,
  nextPageParams?: NextPageParams,
  searchTerm?: string,
  viewSort?: { field?: string; direction?: "asc" | "desc" }
): Promise<HouseholdPeopleResponse> {
  const params = new URLSearchParams()

  if (nextPageParams) {
    params.append("page", nextPageParams.page.toString())
    params.append("per_page", nextPageParams.per_page.toString())
  }

  if (searchTerm) params.append("search", searchTerm)
  if (viewFilterGroup) appendConditionGroupParams(params, viewFilterGroup)
  appendViewSortParams(params, viewSort)

  const response = await apiContextFetch<HouseholdPeopleApiResponse>(
    context,
    `${recordType}s/people?${params.toString()}`,
    { method: "GET" }
  )

  return {
    people: recordType === "client" ? (response.clients ?? []) : (response.prospects ?? []),
    pagination: response.pagination,
  }
}
